import { html, css } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { BaseSection } from "./sectionBase";
import { Parameter, Resource } from "@reporting/rp-types/ext";
import { map } from "lit/directives/map.js";
import rp, { CustomParameter, createCustomParameterFromSqlParameter } from "@reporting/rp-app-host";
import { TreeAdapter, TreeDropdown } from "@omegagrid/tree";

@customElement('rp-fsection-custom')
export class CustomSection extends BaseSection {

	static styles = [...BaseSection.styles, css`
		.row {
			height: 22px;
			display: flex;
			flex-direction: row;
			justify-content: center;
		}

		.row > * {
			height: 100%;
		}

		.row:last-child {
			margin-bottom: 0;
		}

		.row .field-label {
			text-align: right;
			padding: 3px 4px 0 0;
			flex: 0 0 40%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.row .field-control {
			height: 100%;
			flex: 1;
			min-width: 0;
		}

		.row .field-control > * {
			height: 100%;
			width: 100%;
		}
	`];

	@property({type: Array})
	parameters: Parameter[];

	// TODO: implement compatibility with legacy custom scripts (reporting/app/controls/ItemFilter.latte:377)
	@property({type: Array})
	customScripts: Resource[];

	@property()
	createTreeAdapter: (param: Parameter) => TreeAdapter;

	private _components: Map<number, CustomParameter> = new Map();

	updateCustomValue(name: string, value: any) {
		const parameters = this.context.parameters || {};
		if (parameters[name] === value) return;
		parameters[name] = value;
		this.updateContext('parameters', parameters);
	}

	getParameterComponent(index: number) {
		const param = this.parameters[index];
		if (this._components.has(index)) return this._components.get(index);
		const component = createCustomParameterFromSqlParameter(param, null, {mode: 'user'})
		// an empty string means "use the default"; 0 and false are real values
		const savedValue = this.context.parameters?.[param.name];
		if (savedValue != null && savedValue !== '') {
			component.value = savedValue;
		}
		component.addEventListener('change', () => this.updateCustomValue(param.name, component.value));
		if (['m', 's'].includes(component.type)) {
			component.treeAdapter = this.createTreeAdapter(param);
		}
		this._components.set(index, component);
		return component;
	}

	updated(props: Map<string, any>) {
		super.updated(props);
		// console.log(this.customScripts);
	}

	render = () => map(this.parameters, (param, i) => html`
		<div class="row">
			<og-label
				class="field-label"
				tooltipPosition="bottom"
				.text="${param.description || param.name}">
			</og-label>

			<div class="field-control">${this.getParameterComponent(i)}</div>
		</div>
	`);

}
